import * as React from 'react'
import { observer } from 'mobx-react'
import { WrappedComponentProps, injectIntl } from 'react-intl'

import './ReportsHeader.scss'
import ReportsFiltering from '../reports-filtering/ReportsFiltering'
import ReportsSearch from '../reports-search/ReportsSearch'
import { Elements } from '@tfo/common'
const { Heading1 } = Elements

const ReportsHeader = (props: WrappedComponentProps) => (
	<div className="ReportsHeader">
		<div className="ReportsHeader__MainFilter">
			<Heading1>
				{props.intl.formatMessage({ id: 'client.reports.heading' })}
			</Heading1>
			<ReportsFiltering />
		</div>
		<div className="ReportsHeader__SearchSort">
			<ReportsSearch />
		</div>
	</div>
)

export default injectIntl(observer(ReportsHeader))
